// extracted by mini-css-extract-plugin
export default {"container":"Transactions_container__eJZ6d"};